<div class="row">
    <div class="small-dash-item">
        <dash-item-tract></dash-item-tract>
    </div>
    <div class="small-dash-item">
        <dash-item-aggregate-state></dash-item-aggregate-state>
    </div>
    <div class="small-dash-item">
        <dash-item-backup></dash-item-backup>
    </div>
    
    <div class="large-dash-item">
        <dash-item-example></dash-item-example>
    </div>
</div>  
